import React from 'react'
import {Layout} from "antd";
import {Link} from "react-router-dom";
import NavConfig from '../../config/NavConfig'
import Store from "../store";
import {Path} from "../public/path";
import CorpApi from "../public/corp_api";
import IconAccountExit from "../../iconfont/account/exit";
import IconAccountOrder from "../../iconfont/account/order";
import IconPurchase from "../../iconfont/account/purchase";
import IconAccountHelp from "../../iconfont/account/help";
import Logo from '../../images/layout/logo_sologon.svg'
import LogoCollapsed from '../../images/layout/logo_collapsed.svg'
import CloudPath from "../cloud/cloud_path";
import hot from "../../images/home/hot.png";
import IconBypassAccount from "../../iconfont/bypassAccount/bypassAccount";
import IconSubscribeMsg from "../../iconfont/account/subscribeMsg";
import UserInfo from "../common/userInfo/userInfo";
import IconSubAccount from "../../iconfont/layout/subAccount/subAccount";
import IconSubscribeInform from "../../iconfont/layout/subscribeInform/subscribeInform";
import IconSubOrder from "../../iconfont/layout/subOrder/subOrder";
import IconSubHelp from "../../iconfont/layout/subHelp/subHelp";
import {connect} from "react-redux";

const {Header} = Layout;

class QwHeader extends React.Component {

    constructor(props) {
        super(props);
        this.getBread = this.getBread.bind(this);
        this.state = {
            sideCollapsed: false,
            bread: [],
        }
    }

    componentDidMount() {
        this.getBread();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.sideCollapsed) {
            this.setState({
                sideCollapsed: true
            })
        }
        this.getBread();
    }

    getBread() {
        for (let menu of NavConfig) {
            let submenuArr = menu.submenu;
            if (submenuArr) {
                for (let submenu of submenuArr) {
                    if (submenu.pathIn && submenu.pathIn()) {
                        let bread = [];
                        bread.push({
                            title: menu.title
                        });
                        bread.push({
                            title: submenu.title,
                            url: submenu.path
                        });
                        this.setState({
                            bread: bread
                        });
                        break;
                    }
                }
            } else {
                if (menu.pathIn && menu.pathIn()) {
                    let bread = [];
                    bread.push({
                        title: menu.title
                    });
                    this.setState({
                        bread: bread
                    });
                }
            }
        }
    }

    toggle() {
        let collapsed = !this.state.sideCollapsed;
        this.setState({
            sideCollapsed: collapsed,
        });
        if (this.props.toggleSiderCollapsed) {
            this.props.toggleSiderCollapsed(collapsed);
        }
    }

    exit() {
        CorpApi.userExit(() => {
            this.props.history.push(Path.getSigninPath())
        });
    }

    render() {
        return (
            <Header className="qy-header">
                <ul className='qy-header-nav'>
                    <div className="qy-logo">
                        <a href={Path.getHomeHttpUrl()}>
                            {
                                this.state.collapsed ? <img height={32} src={LogoCollapsed}/> :
                                    <img height={32} src={Logo}/>
                            }
                        </a>
                    </div>
                    <ul className='nav-list'>
                        <Link to={Path.getDashboard()}>
                            <li className={Path.isDashboard() ? 'active' : ''}>工作台</li>
                        </Link>
                        {/*<Link to={Path.getZkCloudSeat()}>*/}
                            <li className={Path.isZkCloudHome() || CloudPath.isImChat() ? 'active' : ''} onClick={()=>{
                                if(this.props.subInfo.permissionConf){
                                    let arr = this.props.subInfo.permissionConf.wxworkHelperPro[0].submenu.filter(item=>item.checked)
                                    if(arr.length>0){
                                        let str = arr[0].submenu.filter(el=>el.checked)
                                        if(global.wxworkHelperPro[str[0].key].path == '/im/chat'){
                                            window.open(global.wxworkHelperPro[str[0].key].path)
                                        }else {
                                            this.props.history.push(global.wxworkHelperPro[str[0].key].path)
                                        }
                                    }else {
                                        this.props.history.push(Path.getZkCloudSeat())
                                    }
                                }else if(this.props.subInfo.permissionConf == undefined){
                                    this.props.history.push(Path.getZkCloudSeat())
                                }
                            }}>
                                <span>企微助手Pro </span><img src={hot} className={'hot-icon'}/></li>
                        {/*</Link>*/}
                        {/*<Link to={Path.getDrainageChannel()}>*/}
                            <li className={Path.isIndex() ? 'active' : ''} onClick={()=>{
                                if(this.props.subInfo.permissionConf){
                                    let arr = this.props.subInfo.permissionConf.wxworkHelper[0].submenu.filter(item=>item.checked)
                                    if(arr.length>0){
                                        let str = arr[0].submenu.filter(el=>el.checked)
                                        this.props.history.push(global.wxworkHelper[str[0].key].path)
                                    }else {
                                        this.props.history.push(Path.getDrainageChannel())
                                    }
                                }else if(this.props.subInfo.permissionConf == undefined){
                                    this.props.history.push(Path.getDrainageChannel())
                                }
                            }}>企微助手</li>
                        {/*</Link>*/}
                        {/*<a href={"https://shop.94mxd.com.cn/signin"} target='_blank'>*/}
                        {/*    <li>商城助手</li>*/}
                        {/*</a>*/}
                        <a href={"https://www.94mxd.com.cn/signin"} target='_blank'>
                            <li>公众号助手</li>
                        </a>
                    </ul>
                </ul>
                {
                    this.props.type == 1 ?
                        <ul className='qy-header-colummenu'>
                            {
                                this.props.subInfo.isSub == undefined ? <></> :
                                    <>
                                        {
                                            this.props.subInfo.isSub == 0 ?
                                                <li>
                                                    <Link to={Path.getBypassAccountList()}>
                                                        <IconSubAccount/>
                                                        <span>子账号</span>
                                                    </Link>
                                                </li>
                                                : ''
                                        }
                                        <li>
                                            <Link to={Path.getMineSubscribeMsg()}>
                                                <IconSubscribeInform/><span>订阅通知</span>
                                            </Link>
                                        </li>
                                        {
                                            this.props.subInfo.isSub == 0 ?
                                                <li>
                                                    <Link to={{
                                                        pathname: Path.getMineOrderProductRenewal(),
                                                        state: {product: 'assistantPro'}
                                                    }}>
                                                        <IconSubOrder/><span>订购</span>
                                                    </Link>
                                                </li> : ''
                                        }
                                        <li><a href='https://www.yuque.com/books/share/6158e9bf-c7c5-476a-aec3-202bd5fccccc?#'
                                               target='_blank'><IconSubHelp/><span>帮助</span></a></li>
                                        <UserInfo accountMessage={this.props.subInfo} props={this.props}/>
                                    </>
                            }
                        </ul> :
                        this.props.type == 2 ?
                            <ul className='qy-header-colummenu'>
                                {
                                    this.props.subInfo.isSub == undefined ? <></> :
                                        <>
                                            {
                                                this.props.subInfo.isSub == 0 ?
                                                    <li>
                                                        <Link to={Path.getBypassAccountList()}>
                                                            <IconSubAccount/>
                                                            <span>子账号</span>
                                                        </Link>
                                                    </li>
                                                    : ''
                                            }
                                            <li>
                                                <Link to={Path.getMineSubscribeMsg()}>
                                                    <IconSubscribeInform/><span>订阅通知</span>
                                                </Link>
                                            </li>
                                            {
                                                this.props.subInfo.isSub == 0 ?
                                                    <li>
                                                        <Link to={{
                                                            pathname: Path.getMineOrderProductRenewal(),
                                                            state: {product: 'assistant'}
                                                        }}>
                                                            <IconSubOrder/><span>订购</span></Link>
                                                    </li> : ''
                                            }
                                            <li><a href='https://www.yuque.com/books/share/6158e9bf-c7c5-476a-aec3-202bd5fccccc?#'
                                                   target='_blank'><IconSubHelp/><span>帮助</span></a></li>
                                            <UserInfo accountMessage={this.props.subInfo} props={this.props}/>
                                        </>
                                }
                            </ul> :
                            this.props.type == 3 ?
                                <ul className='qy-header-colummenu'>
                                    {
                                        this.props.subInfo.isSub == undefined ? <></> :
                                            <>
                                                {
                                                    this.props.subInfo.isSub == 0 ?
                                                        <li>
                                                            <Link to={Path.getBypassAccountList()}>
                                                                <IconSubAccount/>
                                                                <span>子账号</span>
                                                            </Link>
                                                        </li>
                                                        : ''
                                                }
                                                <li>
                                                    <Link to={Path.getMineSubscribeMsg()}>
                                                        <IconSubscribeInform/><span>订阅通知</span>
                                                    </Link>
                                                </li>
                                                {
                                                    this.props.subInfo.isSub == 0 ?
                                                        <li>
                                                            <Link to={{
                                                                pathname: Path.getMineOrderProductRenewal(),
                                                                state: {product: 'assistantPro'}
                                                            }}>
                                                                <IconSubOrder/><span>订购</span>
                                                            </Link>
                                                        </li> : ''
                                                }
                                                <li>
                                                    <a href='https://ee3z2ep36h.feishu.cn/docs/doccn1cIp2T9RHlIOEM02bFJKT3' target='_blank'>
                                                        <IconSubHelp/>
                                                        <span>帮助</span>
                                                    </a>
                                                </li>
                                                <UserInfo accountMessage={this.props.subInfo} props={this.props}/>
                                            </>
                                    }
                            </ul> : ''
                }
            </Header>
        );
    }
}

export default connect(state=>{
   const {subReducer} = state
   return {
       subInfo:subReducer
   }
},null)(QwHeader)